import { useState } from 'react';

import { RequestDetail } from './RequestDetail';
import { RequestList } from './RequestList';
import styles from './RequestScreen.module.css';

/**
 * The requests screen (M-09, Task 6) — `/requests`, reachable only for a
 * session holding `request.view` (`App.tsx`'s own `rendersRequests`,
 * `navigation.ts`'s pre-existing `requests` entry — one of the nine Phase 1
 * items that has pointed nowhere until now).
 *
 * A thin wrapper, the `CaseScreen.tsx` shape: this module owns the page
 * container so a detail surface has somewhere to mount beside the list
 * without `RequestList` itself needing to know about it. That surface —
 * reserved here since M-09 as "a request-detail view, should one ever be
 * added" — now exists: `RequestDetail`.
 *
 * THE LIST IS HIDDEN, NEVER UNMOUNTED, when a request is open. `RequestList`
 * owns its queue, its applied filters and its cursor; a ternary that swapped
 * it for the detail would destroy all three, so Back from a request would
 * land on a freshly-mounted, unfiltered, first-page queue. The identical
 * rule `CaseScreen.tsx`'s own docblock sets out at length.
 */

export interface RequestScreenProps {
  permissions: readonly string[];
}

export function RequestScreen({ permissions }: RequestScreenProps) {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className={styles['page']}>
      {selected === null ? null : (
        <RequestDetail
          uuid={selected}
          permissions={permissions}
          onBack={() => {
            setSelected(null);
          }}
        />
      )}

      <div hidden={selected !== null}>
        <RequestList
          permissions={permissions}
          active={selected === null}
          onOpen={(uuid) => {
            setSelected(uuid);
          }}
        />
      </div>
    </div>
  );
}
